// @ts-nocheck
export function getBit(value, bitPosition) {
    return (value >> bitPosition) & 0b1;
}
export function clearBit(value, bitPosition) {
    return value & ~(0b1 << bitPosition);
}
export function setBit(value, bitPosition, bitValue) {
    let result = clearBit(value, bitPosition);
    if (bitValue === 1) {
        result |= 0b1 << bitPosition;
    }
    return result;
}
export function asUint8(value) {
    return value & 0xff;
}
export function asUint16(value) {
    return value & 0xffff;
}
export function convertUint8ToInt8(value) {
    // seems `value < 0x80 ? value : value - 0x100;` also works
    return (value << 24) >> 24;
}
export function getLeastSignificantByte(word) {
    return word & 0xff;
}
export function getMostSignificantByte(word) {
    return (word >> 8) & 0xff;
}
export function getLowerNibble(byte) {
    return byte & 0b1111;
}
export function getUpperNibble(byte) {
    return (byte >> 4) & 0b1111;
}
//# sourceMappingURL=binary-helpers.js.map